import { PROFILE } from '@/clients'
import { djangoErrorHandler } from '@/helpers'

const fetchAvatar = async userId => {
  const route = `${userId}/avatar`
  return PROFILE.get(route)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(djangoErrorHandler(error)))
}

export { fetchAvatar }
